export const PercentageType = {
    RELATIVE: 'Relative',
    ABSOLUTE: 'Absolute'
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/percentage.constants.ts